export default "__VITE_PUBLIC_ASSET__c2e3eb18__"